import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import './Setup.css';
import { Link } from 'react-router-dom';
import { getTodayDate } from './setup_common.js';

const Setup = ({type}) => {
  const { t } = useTranslation();
  
  let procedures;
  switch(type){
    case CURRENT_GOOGLE_SHEETS:
      procedures = t("setup.procedures.current_google_sheets", { returnObjects: true })
      break;
    case CURRENT_MS_EXCEL:
      procedures = t("setup.procedures.current_ms_excel", { returnObjects: true })
      break;
    case LEGACY_GOOGLE_SHEETS:
      procedures = t("setup.procedures.legacy_google_sheets", { returnObjects: true })
      break;
    default:
      procedures = {"main": [], "optional": []}
      break;
  }

  const title = procedures.title;
  const intro = procedures.intro;
  const mainSteps = procedures.main;
  const options = procedures.optional;
  


  //Get today's date for display in the text
  const todayDate = getTodayDate();

  return (
    <div className="setup container">
      
      <h1>{title}</h1>
      <p>{intro}</p>
      
      <div className="setup-steps">
        {
          mainSteps.map((step, index) => 
            <div className='steps-container'>
              <div className='text-content'>
              <h3 className='step-title-container'><span className="step-number">{index+1}</span><span className="step-title">{step.title}</span></h3>

              {step.descriptions &&
                step.descriptions.map(desc => 
                  <div className="word-break-container" style={{"marginBottom": "1rem"}}>
                    <Trans
                      defaults={desc}
                      components={{ 
                        small: <span style={{fontSize: "small"}}></span>,
                        italic: <i></i>, b: <b></b>, 
                        blue: <span style={{color: "blue"}}/>, 
                        red: <span style={{color: "red"}}/>,
                        a: <a target="_blank" rel="noopener noreferrer"></a>
                      }}
                    />
                    
                  </div>
                )
              }
              </div>

              <div className='image-content'>
              {step.img && 
                <img src={step.img} alt={step.altText} width={"100%"} style={{display:"block", marginLeft:"auto", marginRight:"auto"}}></img>
              }
              </div>
            </div>
          )
        }
        <div>
          <h4>{t('setup.optional_settings')}</h4>
          <ul>
            {options.map(option => 
              <li>
                <div style={{marginBottom: "1rem"}}>
                  <span style={{fontWeight: "bold"}}>{option.name}</span>
                  <br/>
                  {option.descriptions.map(desc => 
                    <div className="word-break-container" style={{marginTop: "0.5rem"}}>
                                            
                      <Trans
                        defaults={desc}
                        components={{
                          small: <span style={{fontSize: "small"}}></span>,
                          italic: <i></i>,
                          b: <b></b>, 
                          blue: <span style={{color: "blue"}}/>, 
                          red: <span style={{color: "red"}}/>,
                          a2: <Link href=""></Link>,
                          a: <a target="_blank" rel="noopener noreferrer"></a>,
                          date: <span>{todayDate}</span>
                        }}
                      /> 
                    </div>
                  )}
                  
                </div>
              </li>
            )}
          </ul>

        </div>


        <div className="steps-container">
          
          <h3 className='step-title-container'><span className="step-number">{mainSteps.length + 1}</span><span className="step-title">{t('setup.completed')}</span></h3>
          
        </div>
        
      </div>
      
    </div>
  );
};

export default Setup;

export const CURRENT_GOOGLE_SHEETS = 1;
export const CURRENT_MS_EXCEL = 2;
export const LEGACY_GOOGLE_SHEETS = 3;
